import { render, staticRenderFns } from "./handpickSourceArticleList.vue?vue&type=template&id=8a2135ee&scoped=true&"
import script from "./handpickSourceArticleList.vue?vue&type=script&lang=js&"
export * from "./handpickSourceArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2135ee",
  null
  
)

export default component.exports